











































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
  // For searching.
  private query = '';

  // For creating.
  private roomName = '';
  private shuffleOrder = 'robin';

  private created(): void {
    this.$emit('updateTitle', 'Radiotation');
  }

  private search(): void {
    this.$http.get('search', {params: {query: this.query}}).then((response) => {
      const data = response.data;
      switch (data.type) {
        case 'results':
          this.$root.$data.searchResults = data.results;
          this.$router.push({name: 'RoomSearch', query: {query: this.query}});
          break;
        case 'room':
          this.$root.$data.roomInfo = data.roomInfo;
          this.$router.push({name: 'Room', params: {id: data.roomInfo.room.id}});
          break;
        default:
          console.log(`unknown response type ${data.type}`);
      }
    });
  }

  private createRoom(): void {
    const req = {
      roomName: this.roomName,
      shuffleOrder: this.shuffleOrder,
    };
    this.$http.post('room', req).then((response) => {
      const data = response.data;
      console.log(data);
      if (data.Error) {
        this.$emit('ajaxErr', data);
        return;
      }
      this.$router.push({name: 'Room', params: {id: data.ID}});
    });
  }
}
